export function redirectToAccountPage(accountUid: string) {
    window.location.href = `/app/accounts/${accountUid}/account-dashboard/`;
}
